export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_be657d67-7263-4b97-9002-d5f4ac1dc9a3/artifacts/kooi7ftb_D%26D%20Logo.jpg";

// Partner brand — BSG Auto Glass. Selectable per-job so admin can issue
// BSG-branded paperwork while keeping shared numbering + banking.
export const BSG_LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_dust-mobile-services/artifacts/6m97kcrw_BSG%20Logo%20%28002%29.png";
export const BSG_SITE_URL = "https://www.bsgautoglass.co.za/";
export const BRAND_OPTIONS = [
  { code: "dd", label: "Diesel & Dust", logo_url: LOGO_URL },
  { code: "bsg", label: "BSG Auto Glass", logo_url: BSG_LOGO_URL },
];

export const CONTACT = {
  whatsapp: "+27815069375",
  whatsappDisplay: "+27 81 506 9375",
  phone: "+27815069375",
  phoneDisplay: "+27 81 506 9375",
  email: "admin@dieseldustgroup.co.za",
  website: "www.dieseldustgroup.co.za",
};

export const COVERAGE_AREAS = [
  { name: "Gauteng", code: "GP", note: "HQ region — fastest dispatch" },
  { name: "North West", code: "NW", note: "Mobile teams on rotation" },
  { name: "Mpumalanga", code: "MP", note: "Highveld + lowveld coverage" },
  { name: "Free State", code: "FS", note: "Agricultural & long-haul" },
  { name: "Western Cape / Cape Town", code: "WC", note: "Full metro coverage" },
  { name: "Northern Cape", code: "NC", note: "Mining & rural routes" },
];

export const SERVICES = [
  {
    id: "mobile-replacement",
    title: "Mobile Windscreen Replacement",
    description:
      "We come to you. Same-day on-site replacement with SABS-approved glass for cars, bakkies, trucks and SUVs — anywhere in our coverage area.",
    icon: "Truck",
  },
  {
    id: "chip-repairs",
    title: "Chip Repairs",
    description:
      "Catch the chip before it cracks. Resin-injected repairs that restore strength and stop spread — typically under 30 minutes.",
    icon: "Wrench",
  },
  {
    id: "fleet-maintenance",
    title: "Fleet Maintenance & Surveys",
    description:
      "Scheduled fleet inspections, damage surveys and bulk replacement programmes. Built for logistics operators and large fleets.",
    icon: "ClipboardList",
  },
  {
    id: "agricultural",
    title: "Agricultural Vehicle Windscreens",
    description:
      "Tractor, harvester and farm-implement windscreens replaced on the farm. We work around your season, not against it.",
    icon: "Tractor",
  },
];

export const IMAGES = {
  industrial:
    "https://static.prod-images.emergentagent.com/jobs/be657d67-7263-4b97-9002-d5f4ac1dc9a3/images/18cda4434d65880d5c6eab6c51d1826a3132d89d03135c49ef27205e44ca1275.png",
  saMap:
    "https://static.prod-images.emergentagent.com/jobs/be657d67-7263-4b97-9002-d5f4ac1dc9a3/images/9fee1266c092107ee1f0d7ab349bc2fe6e4d568ea21950958a1bf36c38d31686.png",
  windscreenDamage:
    "https://static.prod-images.emergentagent.com/jobs/be657d67-7263-4b97-9002-d5f4ac1dc9a3/images/2ae8940d5c2141c3891409edcfb215662ff55b785de9923678c1034b275dfcc2.png",
  tractor:
    "https://static.prod-images.emergentagent.com/jobs/be657d67-7263-4b97-9002-d5f4ac1dc9a3/images/646a5f724fe4022b7dc9b48e905e5d67291d06d190a8c8acc18e9a58d16202d4.png",
  mechanic:
    "https://images.unsplash.com/photo-1645445511761-01834d53205b?crop=entropy&cs=srgb&fm=jpg&q=85",
  fleet:
    "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&q=85",
  windscreenInstall:
    "https://plus.unsplash.com/premium_photo-1661266858501-008ae7a80e01?fm=jpg&q=80&w=1600&auto=format&fit=crop",
};
